import { Link } from 'react-router-dom';
import { OpenInNew } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

import { IdChip } from './org-page-redesign/primitives';

/** Copyable id chip with an "open in resource explorer" affordance. */
export function ExplorableId({
  label,
  value,
  resourceType,
  organizationId,
}: {
  label: string;
  value: string;
  resourceType?: string;
  organizationId?: string | null;
}) {
  return (
    <span className="inline-flex items-center gap-1">
      <IdChip label={label} value={value} />
      {resourceType && (
        <Tooltip title="Open in resource explorer">
          <IconButton
            size="small"
            component={Link}
            to={`/admin-v2/resources/${resourceType}/${value}?organization_id=${encodeURIComponent(organizationId || '')}`}
          >
            <OpenInNew fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
    </span>
  );
}
